import { PEOPLE } from "@/mocks/kanliao";

export default function People() {
  return (
    <section id="people" className="relative w-full bg-background-100/70">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-20 md:py-28">
        <div className="mx-auto max-w-2xl text-center">
          <span className="text-xs font-semibold uppercase tracking-widest text-primary-600">人物档案库 · 按人物检索</span>
          <h2 className="mt-3 font-heading text-3xl font-black text-foreground-950 md:text-4xl">按人物归档 · 熟面孔都在目录里</h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600">
            看料站按圈层为常见人物建立档案卡，标注活跃档案与常用标签，点进任一圈层即可定向找瓜、续看更新。
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {PEOPLE.map((p) => (
            <a
              key={p.field}
              href="#search"
              className="group overflow-hidden rounded-xl border border-background-200 bg-background-50 transition hover:-translate-y-1 hover:border-primary-300"
            >
              <div className="relative h-36 w-full overflow-hidden">
                <img
                  src={p.image}
                  alt={p.field}
                  className="h-full w-full object-cover object-top transition duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-950/70 to-transparent" />
                <div className="absolute inset-x-0 bottom-0 flex items-end justify-between p-3">
                  <span className="font-heading text-sm font-bold text-background-50">{p.field}</span>
                  <span className="whitespace-nowrap rounded-full bg-accent-500 px-2 py-0.5 text-xs font-semibold text-foreground-950">
                    {p.active} 活跃
                  </span>
                </div>
              </div>
              <div className="flex items-center justify-between px-4 py-3">
                <div className="flex flex-wrap items-center gap-1.5">
                  {p.tags.map((t) => (
                    <span key={t} className="whitespace-nowrap rounded-full bg-secondary-100 px-2 py-0.5 text-xs text-secondary-900">
                      {t}
                    </span>
                  ))}
                </div>
                <span className="whitespace-nowrap text-xs text-foreground-500">{p.count} 份档案</span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}